import { DataPsmResource } from "../../model/index.js";
import { XML_EXTENSION } from "../vocabulary.js";
class XmlPropertyExtension {
    isAttribute = false;
}
export class DataPsmXmlPropertyExtension extends DataPsmResource {
    static getExtensionData(property) {
        const data = new XmlPropertyExtension();
        Object.assign(data, property?.extensions?.[XML_EXTENSION]);
        return data;
    }
}
//# sourceMappingURL=data-psm-property-extension.js.map